import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Modal } from 'bootstrap';
import { Tutorial } from 'src/app/interfaces/tutorial';
import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';
import { TutorialsService } from 'src/app/services/tutorials.service';

@Component({
  selector: 'app-complete-tutorial-form',
  templateUrl: './complete-tutorial-form.component.html',
  styleUrls: ['./complete-tutorial-form.component.scss'],
})
export class CompleteTutorialFormComponent implements OnInit {
  tutorialsForm: UntypedFormGroup;
  tutorialVideo: any;
  videoSelected: boolean = false;
  selectedTutorial?: Tutorial;
  editing: boolean = false;
  loading: boolean = false;

  @Output() onCreate = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private tutorialsService: TutorialsService,
    private stateService: StateService
  ) {
    this.tutorialsForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      type: [null, [Validators.required]],
      section: [null, [Validators.required]],
      allowedUserType: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.setEventListener();
  }

  setEventListener() {
    const modalElement = document.getElementById('completeTutorialsFormModal');

    modalElement!.addEventListener('shown.bs.modal', () => {
      this.selectedTutorial = this.stateService.selectedTutorial;
      if (this.selectedTutorial) {
        this.editing = true;

        this.name.setValue(this.selectedTutorial.name);
        this.type.setValue(this.selectedTutorial.format);
        this.section.setValue(this.selectedTutorial.section);
        this.videoSelected = true;
        this.tutorialVideo = undefined;
      }
    });
  }

  clearAllFields() {
    this.name.reset();
    this.type.reset();
    this.section.reset();
    this.tutorialVideo = undefined;
    this.videoSelected = false;
    this.loading = false;

    this.stateService.selectedTutorial = undefined;
    this.selectedTutorial = undefined;
  }

  onSubmit() {
    this.loading = true;

    if (this.videoSelected) {
      const tutorial: Tutorial = {
        name: this.name.value,
        description: '',
        file: this.tutorialVideo,
        section: this.section.value,
        format: this.type.value,
        sectionRelationId: 0,
        allowedUserType: this.allowedUserType.value,
      };

      this.tutorialsService.createTutorial(tutorial).subscribe({
        next: (response: any) => {
          this.toastService.success('Se creó correctamente el tutorial.');

          this.loading = true;

          this.clearAllFields();
          this.openTutorialsListModal();
        },
        error: () => {
          this.loading = true;
          this.toastService.alert(
            'No se creó el tutorial, si el error persiste contactate con el soporte.'
          );
        },
      });
    } else {
      this.toastService.alert(
        'No se creó el tutorial, debes seleccionar un video.'
      );
    }
  }

  openTutorialsListModal() {
    this.stateService.openModal.hide();

    const tutorialListModal = new Modal('#tutorialsModal');
    this.stateService.openModal = tutorialListModal;

    tutorialListModal.show();
  }

  onAttachmentSelected(fileEvent: Event) {
    this.videoSelected = true;
    this.tutorialVideo = (fileEvent.target! as any).files[0];
  }

  checkExerciseSection() {
    if (this.section.value == 'EXERCISE') {
      if (
        window.confirm(
          'Si quieres crear tutoriales para ejercicios debes hacerlo desde el apartado de ejercicios. ¿Quieres ser redirigido a dicho apartado?'
        )
      ) {
        this.clearAllFields();

        this.stateService.openModal.hide();

        const exerciseListModal = new Modal('#exerciseListModal');
        this.stateService.openModal = exerciseListModal;

        exerciseListModal.show();
      }
    }
  }

  get name() {
    return this.tutorialsForm.controls['name'];
  }

  get type() {
    return this.tutorialsForm.controls['type'];
  }

  get section() {
    return this.tutorialsForm.controls['section'];
  }

  get allowedUserType() {
    return this.tutorialsForm.controls['allowedUserType'];
  }
}
